(function () {
    'use strict';

    var app = angular.module('inoApp');
    app.directive('sparkline', [function () {
        return {
            restrict: 'A',
            link: link,
            scope: {}
        };

        function link(scope, element, attrs) {
            var $this = angular.element(element);
            var sparklineType = $this.data('sparkline-type') || 'bar';

            // BAR CHART
            if (sparklineType == 'bar') {

                var barColor = $this.data('sparkline-bar-color') || $this.css('color') || '#0000f0';
                var sparklineHeight = $this.data('sparkline-height') || '26px';
                var sparklineBarWidth = $this.data('sparkline-barwidth') || 5;
                var sparklineBarSpacing = $this.data('sparkline-barspacing') || 2;
                var sparklineNegBarColor = $this.data('sparkline-negbar-color') || '#A90329';
                var sparklineStackedColor = $this.data('sparkline-barstacked-color') || ["#A90329", "#0099c6", "#98AA56", "#da532c", "#4490B1", "#6E9461", "#990099", "#B4CAD3"];

                $this.sparkline('html', {
                    barColor: barColor,
                    type: sparklineType,
                    height: sparklineHeight,
                    barWidth: sparklineBarWidth,
                    barSpacing: sparklineBarSpacing,
                    stackedBarColor: sparklineStackedColor,
                    negBarColor: sparklineNegBarColor,
                    zeroAxis: 'false',
                    disableTooltips: true,
                    disableInteraction: true
                });

            }
        }
    }]);
})();